import { ReactElement } from "react";
import { useParams } from "react-router-dom";
import { ContactType, FindAllContactsFilters, FindContactsTargetResponse } from "../../../../lib/filters/dto";
import { useAppSelector } from "../../../../lib/redux/hooks";
import { ProjectDTO } from "../../../projects/dto";
import { EmailsMessagesDTO, FindAllCustomMailsResponseDTO } from "../../../projects/mails/dto";
import { TargetListDTO, TargetListPageEnum } from "../../../targetList/dto";
import { ImportFromCSV } from "../../contacts/csv";
import { ContactsCounterDTO, ContactsIdsResponseDTO } from "../../contacts/dto";
import { ImportFromDatabase } from "./database";
import { ImportType } from "./importType";
import { TargetListPeopleList } from "./list/index";

interface Props {
  showPopup: boolean
  setShowPopup: (action: boolean) => void
  selectedIds: { contactId: string, personId: string }[]
  setSelectedIds: (action: { contactId: string, personId: string }[]) => void
  filters: FindAllContactsFilters
  setFilters: (action: Partial<FindAllContactsFilters>) => void
  setPage: (action: number) => void
  resetFilters: () => void
  contacts: FindContactsTargetResponse<ContactType.PERSON>
  toActivate: number
  counters: ContactsCounterDTO
  targetContactIds: ContactsIdsResponseDTO[]
  targetList: TargetListDTO
  project: ProjectDTO
  isLoadingEmailsHistory: boolean
  emailsHistory: { messages: EmailsMessagesDTO[] }
  templates: FindAllCustomMailsResponseDTO
}

export function TargetListPeople(props: Props) {
  const targetId = useParams().targetId as string;
  const { selectedIds, counters, setSelectedIds, setShowPopup, showPopup, isLoadingEmailsHistory, emailsHistory, filters, setFilters, setPage, resetFilters, contacts, toActivate, targetContactIds, targetList, project, templates } = props
  const targetListsState = useAppSelector((state) => state.targetList);

  const pageMap = new Map<TargetListPageEnum, ReactElement>([
    [TargetListPageEnum.ADD, <ImportType />],
    [TargetListPageEnum.CSV, <ImportFromCSV contactType={ContactType.PERSON} targetListId={targetId} />],
    [TargetListPageEnum.DB, <ImportFromDatabase targetContactIds={targetContactIds} />],
    [TargetListPageEnum.LIST, <TargetListPeopleList
      isLoadingEmailsHistory={isLoadingEmailsHistory}
      emailsHistory={emailsHistory}
      project={project}
      targetList={targetList}
      counters={counters}
      templates={templates}
      toActivate={toActivate}
      contacts={contacts}
      selectedIds={selectedIds}
      setSelectedIds={arg => setSelectedIds(arg)}
      setShowPopup={arg => setShowPopup(arg)}
      showPopup={showPopup}
      filters={filters}
      setFilters={function (action: Partial<FindAllContactsFilters>): void {
        setFilters(action);
      }} setPage={function (action: number): void {
        setPage(action);
      }} resetFilters={function (): void {
        resetFilters();
      }} />],
  ]);

  return (
    <div className="h-full max-h-full">
      {pageMap.get(targetListsState.targetListPage)}
    </div>
  );
}
